import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// 💡 react-router-domからBrowserRouterをインポート
import { BrowserRouter } from 'react-router-dom';
import { TenantProvider, useTenant } from './contexts/TenantContext.js';
import LandingPage from './pages/LandingPage';

/**
 * AppRouter - テナント判定でアプリ or ランディングページを切り替え
 * - ルートドメイン（サブドメインなし）→ ランディングページ
 * - テナントサブドメインあり → テナントアプリ
 */
const AppRouter = () => {
  const { isRootDomain, isLoading } = useTenant();

  if (isLoading) return null;
  if (isRootDomain) return <LandingPage />;
  return <App />;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* 💡 アプリ全体をBrowserRouterとTenantProviderでラップします */}
    <BrowserRouter>
      <TenantProvider>
        <AppRouter />
      </TenantProvider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();